import React, { Component, createElement, Fragment } from 'react';
import { Button, message, Modal, Badge, Table, Typography } from 'antd';
import { connect } from 'react-redux';
import builder, { ComponentsManager } from '@comall-backend-builder/core';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { actions, services } from '@comall-backend-builder/core';
import { get, map } from 'lodash';
import { errorHandle } from '../../services';
const { confirm } = Modal;
const api = services.api;
const { Text } = Typography;

export interface CategoryFilterAttrTableProps {
    entity: Entity;
    params: any;
    componentId: string;
    selectedRowKeys: string[];
}

interface IState {
    selectedKeys: any;
    visible: boolean;
}

class shippingOrder extends Component<CategoryFilterAttrTableProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            selectedKeys: [],
            visible: false,
        };
        this.onDeleteAll = this.onDeleteAll.bind(this);
    }

    showModal = () => {
        const { entity } = this.props;
        const { selectedKeys } = this.state;
        if (selectedKeys.length === 0) {
            message.warning('请至少勾选一条数据再操作');
        } else {
            let itemIds = selectedKeys.join(',');
            console.log(itemIds.toString(''), typeof itemIds.toString(''));
            confirm({
                title: '确认批量发货',
                content: (
                    <div>
                        <div>已选 {selectedKeys.length}个商品,系统将通过接口向顺丰下单</div>
                        <Text type="warning">相同订单号将合并发货,合并后向顺丰下单</Text>
                    </div>
                ),
                onOk() {
                    api.get(
                        { sendOrderNos: itemIds.toString('') },
                        { apiPath: `/8001/order/batch_delivery_new` }
                    )
                        .then(() => {
                            message.success('修改成功');
                            entity.search({
                                ...entity.params,
                                ...entity.filters,
                            });
                        })
                        .catch(errorHandle);
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
            this.setState({
                visible: true,
            });
        }
    };

    onDeleteAll() {
        const {
            entity: {
                filters,
                paging: { page, perPage },
            },
        } = this.props;
        const params = {
            page,
            perPage,
            ...filters,
        };
        api.post(params, { apiPath: `/shippingOrder/export` })
            .then(() => {
                message.success('导出成功，请到 报表管理 - 报表导出管理 中查看');
            })
            .catch(errorHandle);
    }

    renderControllers() {
        const layoutProps = {
            component: 'GridLayout',
            items: [
                {
                    type: 'primary',
                    component: 'BulkOperation',
                    span: 6,
                },
                {
                    component: 'Button',
                    text: '数据导出',
                    span: 10,
                    style: { margin: ' 0 56px' },
                    onClick: this.onDeleteAll,
                },
            ],
        };
        return createElement(ComponentsManager.get('GridLayout'), layoutProps);
    }

    componentDidMount(): void {
        const { entity }: any = this.props;
        // 初始化发货状态值
        builder.getStore().dispatch(actions.filtersChangeAction(entity, { delivery_status: '1' }));
    }

    renderTable() {
        const { entity, componentId, result }: any = this.props;
        const tableProps = {
            entity,
            componentId: componentId + '-Table',
            loadFirstPage: true,
            switchRefresh: true,
            params: {
                ['delivery_status']: '1',
            },
            rowSelection: {
                getCheckboxProps: (record): any => {
                    record.disabled = false;
                    if (
                        record.deliveryStatus == 2 ||
                        record.deliveryStatus == 3 ||
                        record.deliveryStatus == 4
                    )
                        record.disabled = true;
                    return record;
                },
                onChange: (selectedKeys: string[]) => {
                    const selectSendOrder = map(selectedKeys, (index) =>
                        get(result[index], 'sendOrderNo')
                    );
                    this.setState({
                        selectedKeys: selectSendOrder,
                    });
                },
            },
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            scroll: {
                x: true,
            },
            columns: [
                {
                    property: 'channelName',
                },
                {
                    property: 'shopName',
                },
                {
                    property: 'deliveryStatusStr',
                },
                {
                    property: 'expressNumber',
                },
                {
                    property: 'orderType',
                },
                {
                    property: 'orderNo',
                },
                {
                    property: 'receiverName',
                },
                {
                    property: 'sknCode',
                },
                {
                    property: 'skuCode',
                },
                {
                    property: 'quantity',
                },
                {
                    property: 'productName',
                },
                {
                    property: 'sourceShop',
                },
                {
                    property: 'reservoirArea',
                },
                {
                    property: 'remarkStatusStr',
                },
                {
                    property: 'mobile',
                },
                {
                    property: 'area',
                },
                {
                    property: 'address',
                },
                {
                    property: 'orderTimeStr',
                },
            ],
            actionColumn: {
                title: '操作',
                width: 230,
                fixed: 'right',
                style: {
                    height: '80px',
                },
                items: [
                    {
                        type: 'component',
                        component: 'SendGoods',
                    },
                    {
                        type: 'component',
                        component: 'DisplaceSkn',
                    },
                    {
                        type: 'component',
                        component: 'ModifyDelivery',
                    },
                ],
            },
        };
        return createElement(ComponentsManager.get('DataTable'), tableProps);
    }

    render() {
        return (
            <Fragment>
                <div className="optionBox">
                    <Button type="primary" onClick={this.showModal} style={{ margin: '0 20px' }}>
                        批量发货
                    </Button>
                    {this.renderControllers()}
                </div>
                {this.renderTable()}
            </Fragment>
        );
    }
}

function mapStateTopProps(state: any, props: any) {
    const {
        entity: { result },
        entity,
        componentId,
    } = props;
    return {
        result,
        entity,
        componentId,
    };
}

export const ShippingOrder = connect(mapStateTopProps)(shippingOrder);
